import React from 'react';
import './PrivacyPolicy.css';

function PrivacyPolicy() {
  return (
      <div className="privacy-outer">
        <div className="privacy-inner">
          <h1>Privacy Policy</h1>
          <p className="privacy-updated">Last updated: April 2026</p>

          <section>
            <h2>1. Who We Are</h2>
            <p>
              This website is operated by <strong>Charlton Farm Services</strong>, trading as <strong>Plough Breakers</strong>.
            </p>
            <p>
              <strong>Data Controller:</strong> Charlton Farm Services<br />
              <strong>Address:</strong> 2 Little Herdhill Way, Kirriemuir, Angus, DD8 5JZ<br />
              <strong>Website:</strong> ploughbreakers.co.uk
            </p>
            <p>
              We are committed to protecting your personal data and complying with the UK General Data Protection Regulation (UK GDPR) and the Privacy and Electronic Communications Regulations (PECR).
            </p>
          </section>

          <section>
            <h2>2. What Data We Collect</h2>
            <p>We collect the following personal data when you use our website:</p>
            <ul>
              <li><strong>Enquiry forms:</strong> Your name, email address, postcode, phone number (if provided), and the content of your message.</li>
              <li><strong>Usage data:</strong> Pages visited, time spent on pages, browser type, and device information — collected via Google Analytics.</li>
              <li><strong>Cookie data:</strong> Information stored in cookies on your device as described in Section 5.</li>
            </ul>
          </section>

          <section>
            <h2>3. How We Use Your Data</h2>
            <p>We use your personal data for the following purposes:</p>
            <ul>
              <li>To respond to your product enquiries and general contact messages.</li>
              <li>To understand how visitors use our website so we can improve it (Google Analytics).</li>
              <li>To protect our website from spam and abuse (Google reCAPTCHA).</li>
            </ul>
            <p>
              Our lawful basis for processing enquiry data is <strong>legitimate interests</strong> — specifically, responding to customer enquiries about our products. Our lawful basis for analytics is <strong>consent</strong>, which you provide via our cookie consent banner.
            </p>
          </section>

          <section>
            <h2>4. How Long We Keep Your Data</h2>
            <p>
              Enquiry data (your name, email, phone number, postcode and message) is retained for <strong>12 months</strong> from the date of your enquiry, after which it is deleted. You may request deletion at any time — see Section 7.
            </p>
            <p>
              Analytics data is retained in accordance with Google Analytics' default retention settings.
            </p>
          </section>

          <section>
            <h2>5. Cookies</h2>
            <p>
              Our website uses cookies. A cookie is a small file stored on your device that helps us understand how you use our site.
            </p>
            <p>We use the following types of cookies:</p>
            <ul>
              <li><strong>Strictly necessary cookies:</strong> Required for the website to function. These cannot be disabled.</li>
              <li><strong>Analytics cookies:</strong> Set by Google Analytics to help us understand website traffic. These are only set with your consent.</li>
              <li><strong>reCAPTCHA cookies:</strong> Set by Google reCAPTCHA to protect our forms from spam. These are subject to Google's Privacy Policy.</li>
            </ul>
            <p>
              You can manage your cookie preferences at any time using the cookie consent banner on our website. For more information about cookies, visit <a href="https://www.allaboutcookies.org" target="_blank" rel="noopener noreferrer">allaboutcookies.org</a>.
            </p>

            {/* Cookiebot Cookie Declaration — auto-populated after site scan */}

            <script id="CookieDeclaration" src="https://consent.cookiebot.com/54357007-51ed-4cae-9015-a0d2697c5930/cd.js" type="text/javascript" async></script>

          </section>

          <section>
            <h2>6. Third Parties</h2>
            <p>We use the following third-party services which may process your data:</p>
            <ul>
              <li>
                <strong>Google Analytics</strong> — website usage analytics. Google may process data outside the UK.
                See <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.
              </li>
              <li>
                <strong>Google reCAPTCHA</strong> — spam and bot protection on our forms.
                See <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google's Privacy Policy</a>.
              </li>
              <li>
                <strong>Cookiebot</strong> — cookie consent management.
                See <a href="https://www.cookiebot.com/en/privacy-policy/" target="_blank" rel="noopener noreferrer">Cookiebot's Privacy Policy</a>.
              </li>
            </ul>
            <p>We do not sell or share your personal data with any other third parties.</p>
          </section>

          <section>
            <h2>7. Your Rights</h2>
            <p>Under UK GDPR, you have the following rights:</p>
            <ul>
              <li><strong>Right of access</strong> — you can request a copy of the personal data we hold about you.</li>
              <li><strong>Right to rectification</strong> — you can ask us to correct inaccurate data.</li>
              <li><strong>Right to erasure</strong> — you can ask us to delete your personal data.</li>
              <li><strong>Right to restrict processing</strong> — you can ask us to limit how we use your data.</li>
              <li><strong>Right to object</strong> — you can object to us processing your data on the basis of legitimate interests.</li>
              <li><strong>Right to withdraw consent</strong> — where processing is based on consent (e.g. analytics cookies), you can withdraw it at any time via the cookie banner.</li>
            </ul>
            <p>
              To exercise any of these rights, please contact us at the address in Section 1. We will respond within 30 days.
            </p>
            <p>
              If you are unhappy with how we handle your data, you have the right to lodge a complaint with the <a href="https://ico.org.uk" target="_blank" rel="noopener noreferrer">Information Commissioner's Office (ICO)</a>.
            </p>
          </section>

          <section>
            <h2>8. Changes to This Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated date. We encourage you to review this page periodically.
            </p>
          </section>
        </div>
      </div>
  );
}

export default PrivacyPolicy;